import { render, staticRenderFns } from "./tomaio.vue?vue&type=template&id=4eaa0ebb&scoped=true&"
import script from "./tomaio.vue?vue&type=script&lang=js&"
export * from "./tomaio.vue?vue&type=script&lang=js&"
import style0 from "./tomaio.vue?vue&type=style&index=0&id=4eaa0ebb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eaa0ebb",
  null
  
)

export default component.exports